<template>
    <div>
        <HeaderSection icon="far fa-calendar" title="Periodos de Registro">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/administracion')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <el-alert
            title="Establezca un periodo de registro para cada tipo de solicitud."
            type="info"
            show-icon>
        </el-alert>
        <br>

        <el-form ref="periodForm" :model="periodForm" label-width="120px" label-position="top">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="Adquisiciones/Fideicomisos/Convenios"
                                  :rules="[{required: true, message: 'Este campo es requerido', trigger:'change'}]"
                                  prop="requests">
                        <date-picker v-model="periodForm.requests"
                                     v-loading="loading"
                                     format="DD-MM-YYYY"
                                     element-loading-text=""
                                     element-loading-spinner="el-icon-loading"
                                     type="range"
                                     value-type="YYYY-MM-DD"

                                     range></date-picker>
                      <!--  :disabled-date="disabledDates"-->
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Pre-Registro de Usuarios"
                                  :rules="[{required: true, message: 'Este campo es requerido', trigger:'change'}]"
                                  prop="requests">
                        <date-picker v-model="periodForm.users"
                                     format="DD-MM-YYYY"
                                     type="range"
                                     v-loading="loading"
                                     element-loading-text=""
                                     element-loading-spinner="el-icon-loading"
                                     value-type="YYYY-MM-DD"

                                     range></date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row :gutter="20">
            <el-col :span="24" align="end">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/administracion')">
                    Cancelar
                </el-button>
                <el-button
                    type="success"
                    size="medium"
                    icon="far fa-save"
                    @click="saveDates()">
                    Guardar
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import HeaderSection from "../../partials/HeaderSection";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    export default {
        components:{
            HeaderSection,
            DatePicker
        },

        created() {
            this.loading = true;
            axios.get('/api/get-dates').then(response => {
                if(response.data.success){
                    this.periodForm.users = response.data.dates.users;
                    this.periodForm.requests = response.data.dates.requests;
                }else{
                    this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                }
                this.loading = false;
            }).catch(err => {
                this.loading = false;
                this.$store.dispatch('notifications/error', {msg: 'No se pudo completar su solicitud.'}, {root: true});
            })
        },

        data(){
            return{
                periodForm:{
                    requests: [],
                    users: []
                },
                loading: false,
            }
        },

        methods:{
            disabledDates(date){
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                return date < today;
            },

            saveDates(){
                this.$refs['periodForm'].validate(valid => {
                    if(valid){
                        let _params ={
                            period: this.periodForm
                        }
                        axios.post('/api/save-dates',_params).then(response => {
                            if(response.data.success){
                                this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                            }
                        }).catch(err =>{
                            console.log('saveDates',err)
                            this.$store.dispatch('notifications/error', {msg: 'No se pudo completar su solicitud.'}, {root: true});
                        })
                    }else{
                        this.$store.dispatch('notifications/warning', {msg: 'Complete los campos requeridos.'}, {root: true});
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
